import { } from "@heroicons/react/20/solid";
import { PlusCircleIcon } from "@heroicons/react/24/outline";
import classNames from "classnames";
import React from "react";
import { useFieldArray, useWatch } from "react-hook-form";
import { AdminManagePartisanChartState } from "../../hooks/use-admin-manage-partisan-chart";
import Trash from "../../../../../components/icons/trash";

interface AdminManagePartisanChartCandidateNamesProps {
  index: number;
  partyIndex: number;
  adminManagePartisanChartState: AdminManagePartisanChartState;
}

const AdminManagePartisanChartCandidateNamesItem: React.FC<
  AdminManagePartisanChartCandidateNamesProps
> = ({ index, partyIndex, adminManagePartisanChartState }) => {
  const {
    form: { control, register, getValues, setValue },
  } = adminManagePartisanChartState;
  const { fields, append, remove } = useFieldArray({
    control,
    name: `races.${index}.parties.${partyIndex}.candidateNames`,
  });

  const watchFields = useWatch({
    control: control,
    name: `races.${index}.parties.${partyIndex}.candidateNames`,
  });

  const getCountPartyNamesAdded = (partyIndex: number) => {
    let sum = 0;
    const candidateNames =
      getValues().races[index]?.parties[partyIndex]?.candidateNames ?? [];
    candidateNames.forEach((candidate) => {
      if (candidate.name && candidate.name.length) {
        sum += 1;
      }
    });
    return sum;
  };

  return (
    <>
      <div style={{ marginBottom: "20px" }}>
        <span style={{ marginRight: "10px" }}>
          {getValues()?.races[index]?.parties[partyIndex]?.name?.toUpperCase()}
        </span>
        <span>{`(${getCountPartyNamesAdded(partyIndex)}/${getValues()?.races[index].candidates ?? 0
          })`}</span>
      </div>
      <div className="flex flex-col w-[380px]">
        {fields.map((field, i) => {
          return (
            <div className="flex">
              <input
                key={field.id} // important to include key with field's id
                {...register(
                  `races.${index}.parties.${partyIndex}.candidateNames.${i}.name`
                )}
                type="text"
                placeholder="Full name"
                className={"w-full py-3 mb-2 px-4 bg-[#E6EBF5] rounded-md"}
              />
              <input
                {...register(
                  `races.${index}.parties.${partyIndex}.candidateNames.${i}.order`
                )}
                type="number"
                value={Number(i)}
                style={{ display: "none" }}
              />
              <div className="ml-2">
                <button
                  className="p-2 mt-2 bg-gray-200 rounded-full"
                  onClick={() => {
                    remove(i);
                    setValue(
                      `races.${index}.candidates`,
                      getValues().races[index].candidates -
                      1
                    );
                  }}
                >
                  <Trash className="w-4 h-4" />
                </button>
              </div>
            </div>
          );
        })}
      </div>
      <button
        onClick={() => {
          append({ name: "", order: fields.length });
          setValue(
            `races.${index}.candidates`,
            getValues().races[index].candidates
              ? getValues().races[index].candidates + 1
              : 1
          );
        }}
        type="button"
        className={classNames(
          "w-auto font-semibold py-2 flex justify-start items-center mb-8 text-primary-blue rounded-md"
        )}
      >
        <PlusCircleIcon className="w-6 mr-2" />
        Add Another Candidate
      </button>
    </>
  );
};

export default AdminManagePartisanChartCandidateNamesItem;
